module.exports = __webpack_public_path__ + "media/bootstrap-icons/funnel-a50141bb.svg";